import HttpRequest from './HttpRequest';

export default class DiscountService extends HttpRequest {
  static endpoint = 'product-discounts';

  static async getById(id) {
    this.endpoint = 'product-discounts';
    const response = await this.get(id);
    return response;
  }

  static async create(data) {
    this.endpoint = 'product-discounts';
    const response = await this.post(data);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'product-discounts';
    const response = await this.put(id, data);
    return response;
  }

  static async remove(id) {
    this.endpoint = 'product-discounts';
    const response = await this.delete(id);
    return response;
  }
}
